import { Alert, Grid, MenuItem } from '@mui/material';
import { FC } from 'react';
import Signature from '../../../signature/signature';
import Housebillofladingfield from '../../../../pages/dashboard/tradedocuments/housebilloflading/housebillofladingfield/housebillofladingfield';
import { transports } from '../../../../utils/appconstants';
import Customdatepicker from '../../../customdatepicker/customdatepicker';
import NewCustomSelect from '../../../newcustomselect/newcustomselect';
import ChooseDocUpload from '../../../custommodal/ChooseDocUpload';
import UploadLogo from '../common/UploadLogo';
import PortsAutocomplete from '../../../autocompletewithapi/PortsAutocomplete';
import { NumberInput } from '../../../paymentinput/paymentinput';
import BillOfLadenMobileForm from './FormsMobileView/BillOfLaden';
import { TradeDocumentForm } from '../../../../interfaces/TradeDocument';
import {
    BillOfLaden,
    BillOfLadenFormErrors
} from '../../../../interfaces/BillOfLaden';
import CustomTextField from '../../../CustomTextInput';

export interface BillOfLadenFormProps extends TradeDocumentForm {
    payload: BillOfLaden;
    errors: BillOfLadenFormErrors;
}

const BillOfLadenForm: FC<BillOfLadenFormProps> = ({
    error,
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField,
    loading,
    setSignatureUrlBase64,
    signatureUrlBase64,
    setSaveOnly,
    setShowSaveModal,
    totalAmount,
    activeStep,
    setActiveStep,
    showPreview,
    setShowPreview,
    onSaveOnlyAction
}): JSX.Element => {
    return (
        <>
            <BillOfLadenMobileForm
                {...{
                    error,
                    updateField,
                    payload,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField,
                    loading,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    setSaveOnly,
                    setShowSaveModal,
                    totalAmount,
                    activeStep,
                    setActiveStep,
                    showPreview,
                    setShowPreview,
                    onSaveOnlyAction
                }}
            />
            <div className='hidden lg:block form-container'>
                {' '}
                <div className='border-0 border-appcolorgreyfaint'>
                    {error !== null && (
                        <div className='mb-4'>
                            <Alert severity='error'>{error}</Alert>
                        </div>
                    )}

                    <form>
                        <div className=''>
                            <div className='flex gap-2 items-center'>
                                <UploadLogo {...{ payload, updateField }} />

                                <ChooseDocUpload {...{ updateField, payload }}>
                                    <p>Choose Logo</p>
                                </ChooseDocUpload>
                            </div>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: 0
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={12}>
                                                <NewCustomSelect
                                                    hasError={
                                                        errors?.shipperId
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.shipperId
                                                            .length > 0
                                                            ? errors?.shipperId
                                                            : undefined
                                                    }
                                                    selectValue={
                                                        payload.shipperId
                                                    }
                                                    required
                                                    selectOptions={
                                                        corporatePartners as unknown as (
                                                            | string
                                                            | Record<
                                                                  string,
                                                                  unknown
                                                              >
                                                        )[]
                                                    }
                                                    name={'consigneeId'}
                                                    updateField={(_, value) => {
                                                        updateField(
                                                            'shipperId',
                                                            value
                                                        );
                                                        updateField(
                                                            'shipperAddress',
                                                            corporatePartners.filter(
                                                                (item: any) =>
                                                                    item?.id ===
                                                                    value
                                                            )[0]?.address
                                                        );

                                                        updateField(
                                                            'shipperName',
                                                            corporatePartners.filter(
                                                                (item: any) =>
                                                                    item?.id ===
                                                                    value
                                                            )[0]?.name
                                                        );
                                                        updateField(
                                                            'shipperAccountNumber',
                                                            corporatePartners.filter(
                                                                (item: any) =>
                                                                    item?.id ===
                                                                    value
                                                            )[0]
                                                                ?.bankAccountNumber
                                                        );
                                                        updateField(
                                                            'shipperBank',
                                                            corporatePartners.filter(
                                                                (item: any) =>
                                                                    item?.id ===
                                                                    value
                                                            )[0]?.bankName
                                                        );
                                                        updateField(
                                                            'shipperCountry',
                                                            corporatePartners.filter(
                                                                (item: any) =>
                                                                    item?.id ===
                                                                    value
                                                            )[0]?.bankCountry
                                                        );
                                                        updateField(
                                                            'shipperSwiftCode',
                                                            corporatePartners.filter(
                                                                (item: any) =>
                                                                    item?.id ===
                                                                    value
                                                            )[0]?.swiftCode
                                                        );
                                                    }}
                                                    label={'Consigner/Shipper'}
                                                    selectOptionLabel='name'
                                                    loading={
                                                        loadingCorporatepartners
                                                    }
                                                    dropdownRender={() => {
                                                        return (
                                                            <div className='px-4 border-t border-appcolorgreyfaint'>
                                                                <p
                                                                    className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                                    onClick={() => {
                                                                        setShowAddPartner(
                                                                            true
                                                                        );
                                                                    }}
                                                                >
                                                                    + Add a New
                                                                    Partner
                                                                </p>
                                                            </div>
                                                        );
                                                    }}
                                                />

                                                <div className='mt-4'>
                                                    <CustomTextField
                                                        error={
                                                            errors
                                                                ?.shipperAddress
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors
                                                                ?.shipperAddress
                                                                .length > 0
                                                                ? errors?.shipperAddress
                                                                : undefined
                                                        }
                                                        value={
                                                            payload?.shipperAddress
                                                        }
                                                        required
                                                        id='quotation-documentName'
                                                        label='Consigner/Shipper Address'
                                                        name='shipperAddress'
                                                        onChange={(e) => {
                                                            updateField(
                                                                'shipperAddress',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={12} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <CustomTextField
                                            error={errors?.mtdNumber.length > 0}
                                            helperText={
                                                errors?.mtdNumber.length > 0
                                                    ? errors?.mtdNumber
                                                    : undefined
                                            }
                                            required
                                            id='proformainvoice-mtdNumber'
                                            label='MTD No'
                                            name='mtdNumber'
                                            value={payload?.mtdNumber}
                                            onChange={(e) => {
                                                updateField(
                                                    'mtdNumber',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={12} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Customdatepicker
                                            value={payload?.issuedDate || null}
                                            id='quotation-issuedDate'
                                            label='Date of Issue'
                                            name='issuedDate'
                                            updateField={updateField}
                                            error={
                                                errors?.issuedDate.length > 0
                                            }
                                            helperText={
                                                errors?.issuedDate.length > 0
                                                    ? errors?.issuedDate
                                                    : undefined
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <NewCustomSelect
                                            hasError={
                                                errors?.consigneeId.length > 0
                                            }
                                            helperText={
                                                errors?.consigneeId.length > 0
                                                    ? errors?.consigneeId
                                                    : undefined
                                            }
                                            selectValue={payload.consigneeId}
                                            required
                                            selectOptions={
                                                corporatePartners as unknown as (
                                                    | string
                                                    | Record<string, unknown>
                                                )[]
                                            }
                                            name={'consigneeId'}
                                            updateField={(_, value) => {
                                                updateField(
                                                    'consigneeId',
                                                    value
                                                );
                                                updateField(
                                                    'consigneeAddress',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.address
                                                );
                                                updateField(
                                                    'consigneeName',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.name
                                                );
                                                updateField(
                                                    'consigneeAccountNumber',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.bankAccountNumber
                                                );
                                                updateField(
                                                    'consigneeBank',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.bankName
                                                );
                                                updateField(
                                                    'consigneeCountry',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.bankCountry
                                                );
                                                updateField(
                                                    'consigneeSwiftCode',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.swiftCode
                                                );
                                            }}
                                            label={'Consignee'}
                                            // alternativeValue='shippingLineId'
                                            selectOptionLabel='name'
                                            loading={loadingCorporatepartners}
                                            dropdownRender={() => {
                                                return (
                                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                                        <p
                                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                            onClick={() => {
                                                                setShowAddPartner(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            + Add a New Partner
                                                        </p>
                                                    </div>
                                                );
                                            }}
                                        />

                                        <div className='mt-4'>
                                            <CustomTextField
                                                error={
                                                    errors?.consigneeAddress
                                                        .length > 0
                                                }
                                                helperText={
                                                    errors?.consigneeAddress
                                                        .length > 0
                                                        ? errors?.consigneeAddress
                                                        : undefined
                                                }
                                                value={
                                                    payload?.consigneeAddress
                                                }
                                                required
                                                id='quotation-documentName'
                                                label='Consignee Address'
                                                name='consigneeAddress'
                                                onChange={(e) => {
                                                    updateField(
                                                        'consigneeAddress',
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors?.placeOfReceipt
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.placeOfReceipt
                                                            .length > 0
                                                            ? errors?.placeOfReceipt
                                                            : undefined
                                                    }
                                                    required
                                                    id='proformainvoice-placeOfReceipt'
                                                    label='Place of Receipt'
                                                    name='placeOfReceipt'
                                                    value={
                                                        payload?.placeOfReceipt
                                                    }
                                                    onChange={(e) => {
                                                        updateField(
                                                            'placeOfReceipt',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <Customdatepicker
                                                    value={
                                                        payload?.dateOfReceipt !==
                                                        undefined
                                                            ? payload?.dateOfReceipt
                                                            : null
                                                    }
                                                    id='quotation-dateOfReceipt'
                                                    label='Date Of Receipt'
                                                    name='dateOfReceipt'
                                                    updateField={updateField}
                                                    error={
                                                        errors?.dateOfReceipt
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.dateOfReceipt
                                                            .length > 0
                                                            ? errors?.dateOfReceipt
                                                            : undefined
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <div className='mt-4'>
                                                    <CustomTextField
                                                        error={
                                                            errors
                                                                ?.shipmentReferenceNumber
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors
                                                                ?.shipmentReferenceNumber
                                                                .length > 0
                                                                ? errors?.shipmentReferenceNumber
                                                                : undefined
                                                        }
                                                        required
                                                        id='proformainvoice-shipmentReferenceNumber'
                                                        label='Shipment Reference Number'
                                                        name='shipmentReferenceNumber'
                                                        value={
                                                            payload?.shipmentReferenceNumber
                                                        }
                                                        onChange={(e) => {
                                                            updateField(
                                                                'shipmentReferenceNumber',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <NewCustomSelect
                                            hasError={
                                                errors?.notifyPartyId.length > 0
                                            }
                                            helperText={
                                                errors?.notifyPartyId.length > 0
                                                    ? errors?.notifyPartyId
                                                    : undefined
                                            }
                                            selectValue={payload.notifyPartyId}
                                            required
                                            selectOptions={
                                                corporatePartners as unknown as (
                                                    | string
                                                    | Record<string, unknown>
                                                )[]
                                            }
                                            name={'notifyPartyId'}
                                            updateField={(_, value) => {
                                                updateField(
                                                    'notifyPartyId',
                                                    value
                                                );
                                                updateField(
                                                    'notifyPartyName',
                                                    corporatePartners.filter(
                                                        (item: any) =>
                                                            item?.id === value
                                                    )[0]?.name
                                                );
                                            }}
                                            label={'Notify Party'}
                                            // alternativeValue='shippingLineId'
                                            selectOptionLabel='name'
                                            loading={loadingCorporatepartners}
                                            dropdownRender={() => {
                                                return (
                                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                                        <p
                                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                            onClick={() => {
                                                                setShowAddPartner(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            + Add a New Partner
                                                        </p>
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <PortsAutocomplete
                                                    errorCondition={
                                                        errors?.portOfLoadingId
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.portOfLoadingId
                                                            .length > 0
                                                            ? errors?.portOfLoadingId
                                                            : undefined
                                                    }
                                                    id='quotation-portOfLoading'
                                                    label='Port of Loading'
                                                    name='portOfLoadingId'
                                                    updateField={updateField}
                                                    nameValue='portOfLoadingValue'
                                                    value={
                                                        payload.portOfLoadingValue
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <PortsAutocomplete
                                                    errorCondition={
                                                        errors
                                                            ?.portOfDischargeId
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.portOfDischargeId
                                                            .length > 0
                                                            ? errors?.portOfDischargeId
                                                            : undefined
                                                    }
                                                    id='quotation-portOfDischarge'
                                                    label='Port of Discharge'
                                                    name='portOfDischargeId'
                                                    updateField={updateField}
                                                    nameValue='portOfDischargeValue'
                                                    value={
                                                        payload.portOfDischargeValue
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <div className='mt-4'>
                                            <CustomTextField
                                                error={
                                                    errors?.vesselAndVoyage
                                                        .length > 0
                                                }
                                                helperText={
                                                    errors?.vesselAndVoyage
                                                        .length > 0
                                                        ? errors?.vesselAndVoyage
                                                        : undefined
                                                }
                                                required
                                                id='proformainvoice-vesselAndVoyage'
                                                label='Vessel and Voyage'
                                                name='vesselAndVoyage'
                                                value={payload?.vesselAndVoyage}
                                                onChange={(e) => {
                                                    updateField(
                                                        'vesselAndVoyage',
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <Customdatepicker
                                                    value={
                                                        payload?.startDateOfDelivery !==
                                                        undefined
                                                            ? payload?.startDateOfDelivery
                                                            : null
                                                    }
                                                    id='quotation-startDateOfDelivery'
                                                    label='Start Date Of Delivery'
                                                    name='startDateOfDelivery'
                                                    updateField={updateField}
                                                    error={
                                                        errors
                                                            ?.startDateOfDelivery
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.startDateOfDelivery
                                                            .length > 0
                                                            ? errors?.startDateOfDelivery
                                                            : undefined
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <Customdatepicker
                                                    value={
                                                        payload?.endDateOfDelivery !==
                                                        undefined
                                                            ? payload?.endDateOfDelivery
                                                            : null
                                                    }
                                                    id='quotation-endDateOfDelivery'
                                                    label='End Date Of Delivery'
                                                    name='endDateOfDelivery'
                                                    updateField={updateField}
                                                    error={
                                                        errors
                                                            ?.endDateOfDelivery
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.endDateOfDelivery
                                                            .length > 0
                                                            ? errors?.endDateOfDelivery
                                                            : undefined
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <div className='mt-4'>
                                                    <CustomTextField
                                                        error={
                                                            errors
                                                                ?.placeOfDelivery
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors
                                                                ?.placeOfDelivery
                                                                .length > 0
                                                                ? errors?.placeOfDelivery
                                                                : undefined
                                                        }
                                                        required
                                                        id='commercialinvoice-placeOfDelivery'
                                                        label='Place of Delivery'
                                                        name='placeOfDelivery'
                                                        value={
                                                            payload?.placeOfDelivery
                                                        }
                                                        onChange={(e) => {
                                                            updateField(
                                                                'placeOfDelivery',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <Grid
                                            spacing={1}
                                            container
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    select
                                                    error={
                                                        errors?.transport
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.transport
                                                            .length > 0
                                                            ? errors?.transport
                                                            : undefined
                                                    }
                                                    required
                                                    id='commercialinvoice-transport'
                                                    label='Transport'
                                                    value={payload.transport}
                                                    name='transport'
                                                    onChange={(e) => {
                                                        updateField(
                                                            'transport',
                                                            e.target.value
                                                        );
                                                    }}
                                                >
                                                    {transports.map(
                                                        (item, index) => (
                                                            <MenuItem
                                                                value={item}
                                                                key={`transports-${item}-${index}`}
                                                            >
                                                                {item}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </CustomTextField>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors
                                                            ?.placeOfTranshipment
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.placeOfTranshipment
                                                            .length > 0
                                                            ? errors?.placeOfTranshipment
                                                            : undefined
                                                    }
                                                    required
                                                    id='commercialinvoice-placeOfTranshipment'
                                                    label='Route / place of Transhipment'
                                                    value={
                                                        payload.placeOfTranshipment
                                                    }
                                                    name='placeOfTranshipment'
                                                    onChange={(e) => {
                                                        updateField(
                                                            'placeOfTranshipment',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                        <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                            <Grid
                                container
                                spacing={1}
                                sx={{
                                    marginTop: '0px'
                                }}
                            >
                                <Grid item xs={12} md={12} lg={6}>
                                    <CustomTextField
                                        error={
                                            errors?.billOfLadingNumber.length >
                                            0
                                        }
                                        helperText={
                                            errors?.billOfLadingNumber?.length >
                                            0
                                                ? errors?.billOfLadingNumber
                                                : undefined
                                        }
                                        value={payload?.billOfLadingNumber}
                                        required
                                        id='quotation-billOfLadingNumber'
                                        label='Bill of Lading Number'
                                        name='billOfLadingNumber'
                                        onChange={(e) => {
                                            updateField(
                                                'billOfLadingNumber',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <CustomTextField
                                        error={
                                            errors?.salesContractNumber
                                                ?.length > 0
                                        }
                                        helperText={
                                            errors?.salesContractNumber
                                                ?.length > 0
                                                ? errors?.salesContractNumber
                                                : undefined
                                        }
                                        value={payload?.salesContractNumber}
                                        required
                                        id='quotation-salesContractNumber'
                                        label='Sales Contract Number'
                                        name='salesContractNumber'
                                        onChange={(e) => {
                                            updateField(
                                                'salesContractNumber',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>

                        {quoteFields.map((item, index) => (
                            <Housebillofladingfield
                                key={item.id}
                                index={index}
                                id={item.id ?? ''}
                                updateQuoteField={updateQuoteField}
                                removeQuoteField={removeQuoteField}
                                item={item}
                            />
                        ))}

                        <div>
                            <div className='border border-appcolorgreyfaint px-[1rem] pt-8 pb-8'>
                                <div
                                    className='flex items-center cursor-pointer w-fit'
                                    onClick={() => {
                                        addQuoteField();
                                    }}
                                >
                                    <div>
                                        <img
                                            src='/img/vectors/primarydownload.svg'
                                            alt='primarydownload'
                                            className='w-6'
                                        />
                                    </div>
                                    <span className='pl-2 text-appcolorprimary'>
                                        Add Field
                                    </span>
                                </div>
                            </div>

                            <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                        marginTop: '0px'
                                    }}
                                >
                                    <Grid item xs={12} md={12} lg={3}>
                                        <CustomTextField
                                            required
                                            id='housebilloflading-containerNo'
                                            label='Container No(s)'
                                            name='containerNo'
                                            value={payload?.containerNo}
                                            onChange={(e) => {
                                                updateField(
                                                    'containerNo',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={3}>
                                        <CustomTextField
                                            required
                                            id='housebilloflading-sealNumber'
                                            label='Seal No'
                                            name='sealNumber'
                                            value={payload.sealNumber}
                                            onChange={(e) => {
                                                updateField(
                                                    'sealNumber',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={3}>
                                        <CustomTextField
                                            required
                                            id='housebilloflading-kindOfPackages'
                                            label='Package Kind'
                                            name='kindOfPackages'
                                            value={payload.kindOfPackages}
                                            onChange={(e) => {
                                                updateField(
                                                    'kindOfPackages',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={3}>
                                        <CustomTextField
                                            required
                                            id='housebilloflading-totalGrossWeight'
                                            label='Gross Weight'
                                            name='totalGrossWeight'
                                            value={payload.totalGrossWeight}
                                            InputProps={{
                                                inputComponent: NumberInput,
                                                inputProps: {
                                                    min: '0'
                                                }
                                            }}
                                            numericInput
                                            onChange={(e) => {
                                                updateField(
                                                    'totalGrossWeight',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={3}>
                                        <div className='mt-4'>
                                            <CustomTextField
                                                required
                                                id='housebilloflading-measurement'
                                                label='Measurement'
                                                name='measurement'
                                                value={payload.measurement}
                                                onChange={(e) => {
                                                    updateField(
                                                        'measurement',
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <CustomTextField
                                            error={
                                                errors?.deliveryAgent.length > 0
                                            }
                                            helperText={
                                                errors?.deliveryAgent.length > 0
                                                    ? errors?.deliveryAgent
                                                    : undefined
                                            }
                                            required
                                            id='housebilloflading-deliveryAgent'
                                            label='Delivery Agent'
                                            name='deliveryAgent'
                                            value={payload.deliveryAgent}
                                            onChange={(e) => {
                                                updateField(
                                                    'deliveryAgent',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors?.freightAmount
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.freightAmount
                                                            .length > 0
                                                            ? errors?.freightAmount
                                                            : undefined
                                                    }
                                                    required
                                                    id='housebilloflading-freightAmount'
                                                    label='Freight Amount'
                                                    name='freightAmount'
                                                    InputProps={{
                                                        inputComponent:
                                                            NumberInput,
                                                        inputProps: {
                                                            min: '0'
                                                        }
                                                    }}
                                                    numericInput
                                                    value={
                                                        payload.freightAmount
                                                    }
                                                    onChange={(e) => {
                                                        updateField(
                                                            'freightAmount',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors?.noOfOriginals
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.noOfOriginals
                                                            .length > 0
                                                            ? errors?.noOfOriginals
                                                            : undefined
                                                    }
                                                    required
                                                    id='housebilloflading-noOfOriginals'
                                                    label='No of Originals'
                                                    name='noOfOriginals'
                                                    value={
                                                        payload.noOfOriginals
                                                    }
                                                    numericInput
                                                    InputProps={{
                                                        inputComponent:
                                                            NumberInput,
                                                        inputProps: {
                                                            min: '0'
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        updateField(
                                                            'noOfOriginals',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='mt-4'>
                                                    <CustomTextField
                                                        error={
                                                            errors?.placeOfIssue
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors?.placeOfIssue
                                                                .length > 0
                                                                ? errors?.placeOfIssue
                                                                : undefined
                                                        }
                                                        required
                                                        id='housebilloflading-placeOfIssue'
                                                        label='Place of Issue'
                                                        name='placeOfIssue'
                                                        value={
                                                            payload.placeOfIssue
                                                        }
                                                        onChange={(e) => {
                                                            updateField(
                                                                'placeOfIssue',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='mt-4'>
                                                    <CustomTextField
                                                        error={
                                                            errors
                                                                ?.freightPayableAt
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors
                                                                ?.freightPayableAt
                                                                .length > 0
                                                                ? errors?.freightPayableAt
                                                                : undefined
                                                        }
                                                        required
                                                        id='housebilloflading-freightPayableAt'
                                                        label='Freight Payable At'
                                                        name='freightPayableAt'
                                                        value={
                                                            payload?.freightPayableAt
                                                        }
                                                        onChange={(e) => {
                                                            updateField(
                                                                'freightPayableAt',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='w-full mt-2'>
                                                    <Signature
                                                        name='signatureUrl'
                                                        updateField={
                                                            updateField
                                                        }
                                                        setSignatureUrlBase64={
                                                            setSignatureUrlBase64
                                                        }
                                                        signatureUrlBase64={
                                                            signatureUrlBase64
                                                        }
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default BillOfLadenForm;
